import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
});

export const fetchProducts = async () => {
    const { data } = await apiClient.get("/products");
    return data;
};

export const submitOrder = async (payload) => {
    const { data } = await apiClient.post("/orders", payload);
    return data;
};

export const checkoutStatus = async (sessionId) => {
    const { data } = await apiClient.get(`/checkout/status/${sessionId}`);
    return data;
};

export const submitCustomOrder = async (payload) => {
    const { data } = await apiClient.post("/custom-orders", payload);
    return data;
};

export const submitContact = async (payload) => {
    const { data } = await apiClient.post("/contact", payload);
    return data;
};
